var BankPaymentController = require('./bank-payment')

module.exports = BankPaymentController.extend({
})
